import { PUBLIC_BASE_URL_ENV, PUBLIC_LOGIN_URL_ENV } from 'tools/environments';

const parseBaseUrl = () => {
	try {
		return new URL(PUBLIC_BASE_URL_ENV);
	} catch {
		return null;
	}
};

const getFallbackPath = () => {
	const baseUrl = parseBaseUrl();
	if (!baseUrl) return '/';
	return baseUrl.pathname && baseUrl.pathname !== '/' ? baseUrl.pathname : '/';
};

export const buildLoginUrl = (currentPath = getFallbackPath()) => {
	const baseUrl = parseBaseUrl();
	if (!baseUrl) return PUBLIC_LOGIN_URL_ENV;

	const returnUrl = new URL(currentPath, baseUrl.origin).toString();
	try {
		const loginUrl = new URL(PUBLIC_LOGIN_URL_ENV, baseUrl.origin);
		loginUrl.searchParams.set('returnUrl', returnUrl);
		return loginUrl.toString();
	} catch {
		// Fall back to the raw env value if the login URL is invalid,
		// so a misconfiguration does not cause a runtime error.
		return PUBLIC_LOGIN_URL_ENV;
	}
};
